export const GET_ROLES = Symbol('GET_ROLES');
export const GET_ROLES_REQUEST = Symbol('GET_ROLES_REQUEST');
export const GET_ROLES_SUCCESS = Symbol('GET_ROLES_SUCCESS');
export const GET_ROLES_ERROR = Symbol('GET_ROLES_ERROR');

